<template>
  <div>
    <index-header title="Downloads"></index-header>
    <table-actions :perPage="perPage" v-on:per-page-change="setPerPage"></table-actions>
    <table class="table is-hoverable is-fullwidth">
      <thead class="is-size-7">
        <tr>
          <th class="has-text-grey-light">Date</th>
          <th class="has-text-grey-light">Type</th>
          <th class="has-text-grey-light">Status</th>
          <th class="has-text-grey-light">Name</th>
          <th class="has-text-grey-light"></th>
        </tr>
      </thead>
      <tbody>
        <tr
        v-for="userDownload in userDownloads"
        :key="userDownload.id"
        class="is-clickable"
        >
          <td>{{userDownload.created_at | momentDateTime}}</td>
          <td>{{userDownload.type | capitalize}}</td>
          <td>{{userDownload.status | capitalize}}</td>
          <td>{{userDownload.file_name}}</td>
          <td class="is-narrow">
            <a v-if="userDownload.url" class="table-icon tooltip m-r-10" data-tooltip="Download File" v-bind:href="userDownload.url" download="true">
              <IconDownload/>
            </a>
            <a v-if="userDownload" class="table-icon tooltip m-r-20" data-tooltip="Delete Download" @click="destroy(userDownload.id)">
              <IconX/>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <pagination
      :currentPage="currentPage"
      :totalPages="totalPages"
      v-on:current-page-change="setCurrentPage"
    ></pagination>
  </div>
</template>

<script>
import uiHelper from '@/mixins/uiHelper'
import { IconDownload, IconX } from '@/Icons/IconBase'
import { DOWNLOAD_ALL, DOWNLOAD_DELETE } from '@/store/actions'
import { DOWNLOAD_CURRENT_PAGE_SET, DOWNLOAD_PER_PAGE_SET, DOWNLOAD_SEARCH_VALUE_SET } from '@/store/mutations'

export default {
  name: 'Downloads',
  mixins: [uiHelper],
  data() {
    return {
      currentPageMutation: DOWNLOAD_CURRENT_PAGE_SET,
      perPageMutation: DOWNLOAD_PER_PAGE_SET,
      searchValueMutation: DOWNLOAD_SEARCH_VALUE_SET,
      selectedDownload: {}
    }
  },

  components: {
    IconDownload,
    IconX
  },

  computed: {
    resourceState() {
      return this.$store.state.downloads
    },

    userDownloads() {
      return this.$store.state.downloads.downloads
    }
  },
  methods: {
    handleSearchInput(value) {
      this.setSearchValue(value, this)
    },

    load() {
      this.$store.dispatch(DOWNLOAD_ALL)
    },

    destroy(id) {
      let self = this
      this.$store.dispatch('confirm', 'Are you sure you want to delete this download?').then(resp => {
        if (resp === true) {
          this.$store.dispatch(DOWNLOAD_DELETE, id)
            .then(function () {
              self.$store.commit('alert', 'Download Deleted')
            })
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
